import React from 'react';

import { NodeEnv } from 'reservations/base/constants/environments';

const setupAxeCore = () => {
  if (
    typeof window !== 'undefined' &&
    process.env.NODE_ENV !== NodeEnv.PRODUCTION
  ) {
    const ReactDOM = require('react-dom');
    const axe = require('@axe-core/react');
    axe(React, ReactDOM, 1000);
  }
};

export default setupAxeCore;
